/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Pagetitle3Inputs */

const en_settings_reportingapikeys_pagetitle3 = /** @type {(inputs: Settings_Reportingapikeys_Pagetitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporting API Key Management`)
};

/**
* | output |
* | --- |
* | "Reporting API Key Management" |
*
* @param {Settings_Reportingapikeys_Pagetitle3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_pagetitle3 = /** @type {((inputs?: Settings_Reportingapikeys_Pagetitle3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Pagetitle3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_pagetitle3(inputs)
});
export { settings_reportingapikeys_pagetitle3 as "settings_reportingApiKeys_pageTitle" }